/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Text, View } from "@aws-amplify/ui-react";
export default function BtnKanryo(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="80px"
      height="26px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      padding="0px 0px 0px 0px"
      {...rest}
      {...getOverrideProps(overrides, "BtnKanryo")}
    >
      <View
        width="80px"
        height="26px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0%"
        bottom="0%"
        left="0%"
        right="0%"
        borderRadius="13px"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(43,133,255,1)"
        {...getOverrideProps(overrides, "Rectangle 27")}
      ></View>
      <Text
        fontFamily=""
        fontSize="12px"
        fontWeight=""
        color="rgba(255,255,255,1)"
        lineHeight="12px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        width="32px"
        height="unset"
        gap="unset"
        alignItems="unset"
        position="absolute"
        top="26.92%"
        bottom="26.92%"
        left="30%"
        right="30%"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="完了"
        {...getOverrideProps(overrides, "\u5B8C\u4E86")}
      ></Text>
    </View>
  );
}
